export default "__VITE_ASSET__CtVfMaPM__"